export enum FieldType {
  ID = 'ID',
  TEXT = 'TEXT',
  LONG_TEXT = 'LONG_TEXT',
  NUMBER = 'NUMBER',
  DATE = 'DATE',
  TOUR_PRICE_ARRAY = 'TOUR_PRICE_ARRAY',
  TOUR_STATUS = 'TOUR_STATUS',
  DROPDOWN = 'DROPDOWN',
  CHECKBOX = 'CHECKBOX',
  MULTISELECT = 'MULTISELECT',
  DATE_TIME = 'DATE_TIME',
  MONEY_VALUE = 'MONEY_VALUE',
  NESTED_CLIENT = 'NESTED_CLIENT',
  NESTED_TOUR = 'NESTED_TOUR',
  NESTED_PARTICIPANT = 'NESTED_PARTICIPANT',
  NESTED_INSURANCE = 'NESTED_INSURANCE',
  NESTED_TRANSPORT_VARIANT = 'NESTED_TRANSPORT_VARIANT',
  NESTED_OBJECT_LIST = 'NESTED_OBJECT_LIST',
  NESTED_BOOKING = 'NESTED_BOOKING',
  NESTED_WAITLIST_CLIENT = 'NESTED_WAITLIST_CLIENT',
  NESTED_APP_USER = 'NESTED_APP_USER',
  TOUR_NAME = 'TOUR_NAME',
  AVAILABILITY = 'AVAILABILITY',
  DATE_RANGE = 'DATE_RANGE',
  NESTED_INSTALLMENT_DETAILS = 'NESTED_INSTALLMENT_DETAILS',
  PHONE_NUMBER = 'PHONE_NUMBER',
  REGISTRATION_DETAILS = 'REGISTRATION_DETAILS',
  ENUM = 'ENUM',
  FILE = 'FILE',
  LINK_OR_FILE = 'LINK_OR_FILE',
  MESSAGE_STATUS = 'MESSAGE_STATUS',
  TAGS = 'TAGS',
  TOUR_DESTINATION = 'TOUR_DESTINATION',
}
